
import { 
  collection, 
  doc, 
  getDoc, 
  addDoc,
  serverTimestamp
} from "firebase/firestore";
import { db } from "../config";

export const createTransfer = async (
  fromUserId: string,
  toUserId: string,
  amount: number,
  description: string
) => {
  try {
    // Get both users to validate they're in the same family
    const fromUserRef = doc(db, "users", fromUserId);
    const toUserRef = doc(db, "users", toUserId);
    
    const [fromUserDoc, toUserDoc] = await Promise.all([
      getDoc(fromUserRef),
      getDoc(toUserRef)
    ]);
    
    if (!fromUserDoc.exists() || !toUserDoc.exists()) {
      throw new Error("One or both users not found");
    }
    
    const fromUserData = fromUserDoc.data();
    const toUserData = toUserDoc.data();
    
    // Check if users are in the same family
    if (fromUserData.familyId !== toUserData.familyId) {
      throw new Error("Users must be in the same family");
    }
    
    // Check if sender has sufficient balance
    if (fromUserData.balance < amount) {
      throw new Error("Insufficient balance");
    }
    
    // Create transfer request
    const transferRef = await addDoc(collection(db, "transfers"), {
      fromUserId,
      toUserId,
      amount,
      description: description || `Transfer to ${toUserData.firstName}`,
      status: 'pending',
      familyId: fromUserData.familyId,
      createdAt: serverTimestamp()
    });
    
    return transferRef.id;
  } catch (error) {
    console.error("Error creating transfer: ", error);
    throw error;
  }
};
